import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Dashboard from "@/pages/Dashboard";
import BrokerTracker from "@/pages/BrokerTracker";
import ActivityLog from "@/pages/ActivityLog";
import WeeklyKPIs from "@/pages/WeeklyKPIs";
import Users from "@/pages/Users";
import Submissions from "@/pages/Submissions";
import GoGets from "@/pages/GoGets";
import Profile from "@/pages/Profile";
import Leads from "@/pages/Leads";
import GetAppointed from "@/pages/GetAppointed";

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Navigate to="/app" replace />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Navigate to="/login" replace />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/accept-invite" element={<AcceptInvite />} />
                        <Route path="/get-appointed" element={<GetAppointed />} />
                        <Route
                            path="/app"
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="brokers" element={<BrokerTracker />} />
                            <Route path="activity" element={<ActivityLog />} />
                            <Route path="weekly-kpis" element={<WeeklyKPIs />} />
                            <Route path="submissions" element={<Submissions />} />
                            <Route path="go-gets" element={<GoGets />} />
                            <Route path="leads" element={<Leads />} />
                            <Route path="users" element={<Users />} />
                            <Route path="profile" element={<Profile />} />
                            <Route path="add-broker" element={<Navigate to="/app/brokers?add=1" replace />} />
                            <Route path="log-activity" element={<Navigate to="/app/activity?log=1" replace />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/app" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </div>
    );
}
